import { RouteObject } from "react-router";
import SidebarLayout from "src/layouts/SidebarLayout/SidebarLayout";
import HomePage from "src/content/pages/HomePage";
import UsagePage from "./content/pages/DashboardPages/UsagePage";
import BillingPage from "./content/pages/DashboardPages/BillingPage";
import ContactUs from "./content/pages/ContactUs";
import DashboardPage from "./content/pages/DashboardPages/DashboardPage";
import PricingPage from "./content/pages/PricingPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/contact",
    element: <ContactUs />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/dashboard",
    element: <SidebarLayout />,
    children: [
      ,
      {
        path: "home",
        element: <DashboardPage />,
      },
      {
        path: "home/success",
        element: <DashboardPage />,
      },
      {
        path: "home/cancel",
        element: <DashboardPage />,
      },
      {
        path: "usage",
        element: <UsagePage />,
      },
      {
        path: "billing",
        element: <BillingPage />,
      },
    ],
  },
];

export default routes;
